import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BookletView } from "../components/BookletView";
import { useBooklet } from "@/application/hooks/useBooklet";
import { Button } from "@tabipla/ui/components/button";
import { Loader2, Home, AlertCircle } from "lucide-react";

export function Booklet() {
  const { t } = useTranslation();
  const { shareCode } = useParams<{ shareCode: string }>();
  const { data, isLoading, error } = useBooklet(shareCode);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center p-4">
        <AlertCircle className="mb-4 h-12 w-12 text-destructive" />
        <h1 className="mb-2 text-xl font-bold">{t("booklet.notFound")}</h1>
        <p className="mb-4 text-muted-foreground">{t("booklet.notFoundDescription")}</p>
        <Button asChild>
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            {t("booklet.backToHome")}
          </Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <BookletView data={data} />
    </div>
  );
}
